import { render } from "./PopBalloon.vue?vue&type=template&id=c5b6c0da&scoped=true"
import script from "./PopBalloon.vue?vue&type=script&lang=js"
export * from "./PopBalloon.vue?vue&type=script&lang=js"

import "./PopBalloon.vue?vue&type=style&index=0&id=c5b6c0da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b6c0da"]])

export default __exports__